document.addEventListener('DOMContentLoaded', () => {
  const floatingBtn = document.querySelector('.btn-bounce-primary__float')
  const mainButton = document.querySelector('.btn-bounce-primary__static')

  if (!mainButton) return

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          floatingBtn.classList.add('visible')
        } else {
          floatingBtn.classList.remove('visible')
        }
      })
    },
    {
      threshold: 0.1, // 10% видимости элемента менять тут
    }
  )

  observer.observe(mainButton)
})
